import React from "react";
import classNames from "classnames";

const Loader = ({ height = 30, width = 30, fullPage = false }) => {
  return (
    <div
      className={classNames({
        "row flex-grow-1": fullPage,
      })}
    >
      <div className="content-background d-flex justify-content-center align-items-center">
        <img
          src="assets/img/loading.gif"
          alt="loading"
          height={height}
          width={width}
        />
      </div>
    </div>
  );
};

export default Loader;
